<template>
  <div class="file-thumbnail">
    <div class="icon">
      <img :src="getFileIcon(contentType)" />
    </div>
    <div class="filename">{{ fileName }}</div>
  </div>
</template>

<script>
export default {
  props: {
    contentType: {
      type: String,
    },

    fileName: {
      type: String,
    },
  },

  methods: {
    getFileIcon(c) {
      if (c === 'application/pdf') {
        return require('@/assets/icons/documents/pdf.svg');
      }
      return;
    },
  },
};
</script>

<style scoped lang="scss">
.file-thumbnail {
  background: white;
  padding: 1rem;
  border-radius: $border-radius;
  box-shadow: $box-shadow-2;
  text-align: center;
  cursor: pointer;
  border: 1px solid $gray-200;
  transition: $transition-base;

  .icon {
    padding: 1rem;
  }

  .filename {
    font-size: 0.7rem;
  }
}

.file-thumbnail:hover {
  box-shadow: $box-shadow-3;
  border: 1px solid $gray-100;
}
</style>
